import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const DEFAULT_BRAND = '#4B3F9E';

interface ThemeState {
  brandColor: string;
  setBrandColor: (color: string) => void;
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      brandColor: DEFAULT_BRAND,
      setBrandColor: (brandColor) => set({ brandColor }),
    }),
    { name: 'zelog-theme-color' },
  ),
);
